module.exports = __webpack_public_path__ + "static/media/bg-loyalty.10958877.png";